import { Lead } from '../@types/lead'

const GRACE_PERIOD = 20 * 60 * 1000

export const isWithinGracePeriod = (lead: Lead): boolean => {
  if (lead.created) {
    const now: number = new Date().getTime()
    const createdDate: number = new Date(lead.created).getTime()
    return now - createdDate < GRACE_PERIOD
  }
  return false
}
